import { PromotionBanners } from "@/components/homepage/PromotionBanners";
import { FantasySportsSection } from "@/pages/Top/FantasySportsSection";
import { PointSection } from "@/pages/Top/PointSection";
import { StepsSection } from "@/pages/Top/StepsSection";
import { useFirstVisitStore } from "@/store";
import { useAuthStore } from "@/store/auth.store";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const TopPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const setIsFirstVisit = useFirstVisitStore((state) => state.setIsFirstVisit);
  const authState = useAuthStore((state) => state.authState);
  const [isViewedTop] = useState<boolean>(location.state?.isViewedTop || false);

  const isFromMyPage = location.state?.fromMyPage;
  const shouldShowButton = !isFromMyPage && authState === "unauthenticated";
  useEffect(() => {
    if (authState === "authenticated" && !isViewedTop) {
      navigate("/");
    }
    window.history.replaceState({}, "");
  }, [authState, navigate, isViewedTop]);

  useEffect(() => {
    setIsFirstVisit(false);
  }, [setIsFirstVisit]);

  return (
    <div className="flex justify-center min-h-screen">
      <div className="w-full max-w-[768px] mx-auto min-h-screen bg-white">
        <div className="flex flex-col min-h-[calc(100vh-72px)]">
          {/* Banner Section */}
          <PromotionBanners />

          {/* Main Content Section */}
          <div className="text-white">
            <div className="w-full mx-auto">
              <img src="/assets/top-main-img.png" alt="Main Content Background" className="w-full mx-auto" />
            </div>
            <div
              className="w-full mx-auto relative text-white flex justify-center items-center py-14 flex-col"
              style={{
                backgroundImage: "url('/assets/top-thumba-background.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <img src="/assets/top-thumba-jp.png" alt="Top Thumba" className="w-[376px]" />

              <div className="w-[376px] h-[107px] bg-white mt-10 px-2 py-3 rounded-[4px] flex justify-center">
                <div className="flex justify-center items-end flex-col">
                  <div className="flex justify-center items-center gap-1">
                    <img src="/assets/safety_icon.svg" alt="safety icon" />

                    <div className="flex flex-col">
                      <div className="text-primary text-[12.5px] font-extrabold">
                        日本の法令を遵守した安心・安全なサービスです。
                      </div>

                      <div className="text-primary text-[10px] font-medium">
                        サンバは、スポーツベッティングやオンラインカジノ等の違法ギャンブルとは無関係で、日本の法令を遵守した安心・安全なサービスです。
                      </div>
                    </div>
                  </div>
                  <div
                    className="text-secondary text-right text-[9px] font-medium cursor-pointer"
                    onClick={() => window.open("https://thumba.jp/media/216", "_blank")}
                  >
                    安心安全の取り組みについて <span>▶︎</span>
                  </div>
                </div>
              </div>
            </div>
            <StepsSection />
            <PointSection />
            <FantasySportsSection />

            {/* 今すぐ無料ではじめる Button */}
            {shouldShowButton && (
              <div className="sticky bottom-4 w-full flex justify-center pb-4 px-4">
                <button
                  type="button"
                  className="relative z-20 text-2xl font-bold bg-gradient-yellow border border-[#FFE501] text-black py-2 px-4 rounded-md w-[380px] sm:w-[700px] xl:w-[700px] h-[70px]"
                  onClick={() => navigate("/")}
                >
                  今すぐ無料ではじめる
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
